import React from "react"
import styled from "styled-components"

const SoundPlayer = ({ url }) => {
  return (
    <Root>
      <TimeContainer>
        <audio src={url} controls autoPlay />
      </TimeContainer>
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  background-color: rgba(0, 0, 0, 0.3);
  justify-content: center;
  margin-top: 18vh;
`
const TimeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export default SoundPlayer
